﻿window.dict_consumercontract_editpower = function () {
    var _id;
    var instance = {
        init: function (id) {

            _id = id;

            im_decimal.mask("#dict_consumercontract_editpower_power tr td input");
            var filedsCollection = document.getElementsByClassName("maskfield");

            for (var i = 0; i < filedsCollection.length; i++) {
                filedsCollection[i].onpaste = function (e) {

                    var valuetovalidate = e.clipboardData.getData('Text').replace(".", ",");
                    validate_pmax_input.validate(e, valuetovalidate, _id);
                };
                filedsCollection[i].onkeypress = function (e) {

                    var valuetovalidate = e.target.value.replace(".", ",");
                    validate_pmax_input.validate(e, valuetovalidate, _id);
                };
                filedsCollection[i].onkeydown = function (e) {

                    var valuetovalidate = e.target.value.replace(".", ",");
                    validate_pmax_input.validate(e, valuetovalidate, _id);
                };
            }
        },
        
    };
    var im_decimal = Inputmask("decimal", {
        radixPoint: ',',
        inputtype: "text",
        digits: 5,
        allowMinus: true
    });
    return instance;
}();
